import { articles, type Article } from '../mocks/articles';
import { categories, hotTopics, type Category } from '../mocks/categories';
import { specials, type Special } from '../mocks/specials';

export type { Article, Category, Special };

export function getCategories(): Category[] {
  return categories;
}

export function getCategoryByKey(key: string): Category | undefined {
  return categories.find((c) => c.key === key);
}

export function getArticles(): Article[] {
  return articles;
}

export function getArticleById(id: string): Article | undefined {
  return articles.find((a) => a.id === id);
}

export function getFeaturedArticles(): Article[] {
  return articles.filter((a) => a.featured);
}

export function getLatestArticles(limit?: number): Article[] {
  const sorted = [...articles].sort(
    (a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime(),
  );
  return typeof limit === 'number' ? sorted.slice(0, limit) : sorted;
}

export function getHotArticles(limit?: number): Article[] {
  const sorted = [...articles].sort((a, b) => b.views - a.views);
  return typeof limit === 'number' ? sorted.slice(0, limit) : sorted;
}

export function getArticlesByCategory(key: string): Article[] {
  return articles.filter((a) => a.category === key);
}

export function getRelatedArticles(article: Article, limit = 3): Article[] {
  return articles
    .filter((a) => a.id !== article.id && a.category === article.category)
    .sort((a, b) => b.views - a.views)
    .slice(0, limit);
}

export interface SearchOptions {
  category?: string;
  sort?: 'latest' | 'hot';
}

export function searchArticles(keyword: string, options: SearchOptions = {}): Article[] {
  const kw = keyword.trim().toLowerCase();
  let result = articles;
  if (kw) {
    result = result.filter((a) => {
      const text = `${a.title} ${a.summary} ${a.tags.join(' ')} ${a.author}`.toLowerCase();
      return text.includes(kw);
    });
  }
  if (options.category && options.category !== 'all') {
    result = result.filter((a) => a.category === options.category);
  }
  const sorted = [...result];
  if (options.sort === 'hot') {
    sorted.sort((a, b) => b.views - a.views);
  } else {
    sorted.sort(
      (a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime(),
    );
  }
  return sorted;
}

export function getHotTopics() {
  return hotTopics;
}

export function getSpecials(): Special[] {
  return specials;
}

export function getSpecialById(id: string): Special | undefined {
  return specials.find((s) => s.id === id);
}

export function formatViews(views: number): string {
  if (views >= 10000) {
    return `${(views / 10000).toFixed(1)}万`;
  }
  return `${views}`;
}

export function formatDate(value: string): string {
  return value.slice(0, 10);
}